import {
  BookOpen,
  ChevronRight,
  GraduationCap,
  Landmark,
  Link,
  Mail,
  ShoppingCart,
} from 'lucide-react'
import { Button } from '@/components/ui/button'
import { connectionTypeName } from './types'
import type { ConnectionType } from './detailTypes'

const icons = {
  woocommerce: ShoppingCart,
  moodle: GraduationCap,
  xero: Landmark,
  mailchimp: Mail,
  quickbooks_online: BookOpen,
}
const descriptions: Record<string, string> = {
  woocommerce: 'Orders and Academy purchases from your WooCommerce store',
  moodle: 'Course enrolments and completions from your Moodle site',
  xero: 'Invoices and contacts from your Xero organisation',
  mailchimp: 'Newsletter subscribers and engagement from your MailChimp audience',
}
export function ConnectionTypeIcon({ type }: { type: string }) {
  const Icon = icons[type as keyof typeof icons] ?? Link
  return (
    <span
      className="inline-flex size-6 shrink-0 items-center justify-center rounded-sm bg-primary/10 text-primary"
      aria-hidden="true"
    >
      <Icon className="size-3.5" strokeWidth={1.5} />
    </span>
  )
}
export function ConnectionTypePicker({
  types,
  onChoose,
}: {
  types: ConnectionType[]
  onChoose: (type: ConnectionType) => void
}) {
  if (!types.length)
    return <p className="text-body-sm text-muted-foreground">No connection types are available.</p>
  return (
    <div className="divide-y divide-border">
      {types.map((item) => (
        <Button
          key={item.type}
          variant="ghost"
          className="h-auto w-full justify-start gap-3 rounded-none px-0 py-2 text-left"
          onClick={() => onChoose(item)}
        >
          <ConnectionTypeIcon type={item.type} />
          <span className="flex-1 leading-snug">
            <span className="block text-body-sm font-medium">{connectionTypeName(item.type)}</span>
            <span className="block text-caption font-normal text-muted-foreground">
              {descriptions[item.type]}
            </span>
          </span>
          <ChevronRight className="size-4 text-muted-foreground" strokeWidth={1.5} />
        </Button>
      ))}
    </div>
  )
}
